import { render, staticRenderFns } from "./priceTryOn.vue?vue&type=template&id=36b8d454&scoped=true"
import script from "./priceTryOn.vue?vue&type=script&lang=js"
export * from "./priceTryOn.vue?vue&type=script&lang=js"
import style0 from "./priceTryOn.vue?vue&type=style&index=0&id=36b8d454&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b8d454",
  null
  
)

export default component.exports